<div class="bg-th-yellow mt-0 container-fluid py-2">
    <div class="d-flex justify-content-between align-content-center">
        <i class="fa fa-arrow-left text-secondary my-auto pointer text-dark" routerLink="/"></i>
        <a class="d-flex align-items-center text-secondary f18 my-auto text-dark">
            <span class="fw-bold">  فیلیت دیاگ - کاربران </span>
        </a>
    </div>
</div>
<main class="px-2">
<!-- جدول اطلاعات -->
    <div class="border border-2 container-fluid row gx-0 gy-2 mt-3 p-2">
        <!-- جستجو -->
        <div class="col-8 p-1">
            <input type="text" 
                class="w-100 form-control" 
                (input)="filterResult($event.target.value)"
                placeholder="جستجو کنید ..." >
        </div>
        <!-- خروجی اکسل -->
        <div class="col-auto p-1">
            <button class="w-100 h-100 btn btn-success" (click)="exportExcel()">
                &nbsp; خروجی اکسل &nbsp;
            </button>
        </div>
        <!-- جدول اطلاعات -->
        <div class="section border border-2 mt-2">
            <table class="col-12 table table-striped rounded-3" id="Export_Excel">
                <thead>
                    <tr class="text-center">
                        <th scope="col" class="">#</th>
                        <th scope="col" class=""> عملیات </th>
                        <th scope="col" class=""> نام و نام‌خانوادگی </th>
                        <th scope="col" class=""> موبایل </th>
                        <th scope="col" class=""> تعداد ورود </th>
                        <th scope="col" class=""> تاریخ بروز رسانی </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="f14 text-center" *ngFor="let item of userList;let i=index">
                        <th class="text-dark"> {{ i + 1 | faNum }}</th>
                        <th class="">
                            <i class="fa fa-edit mx-2 fa-lg text-primary pointer" title=" ویرایش" (click)="openEditModal(item)"></i>
                            <i class="fa fa-file-text-o mx-2 fa-lg pointer" title="لاگ فرامین" (click)="openCommandLog(item)"></i>
                            <i class="fa fa-history mx-2 fa-lg pointer" title="سابقه اطلاعات" (click)="openPidLog(item)"></i>
                            <i class="fa fa-car mx-2 fa-lg text-success pointer" title="اطلاعات ECU موتور" (click)="openWorkSpace(item)"></i>
                        </th>
                        <td> {{ item.strFullName | faNum }} </td>
                        <td> {{ item.strMobile | faNum }} </td>
                        <td> {{ (item.iInput | number) | faNum }} </td>
                        <td> {{ (item.strLastLoginDateTime ) | faNum }} </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</main>
<!-- مودل لاگ فرامین -->
 <div class="modal fade" id="commandLogModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content dirI">
            <div class="modal-header dirI">
                <h5 class="modal-title" id="exampleModalLabel">
                    لاگ فرامین
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
                <!-- فیلتر -->
                <div class=" container-fluid row g-0">
                    <div class="col-md-10">
                        <input type="text"
                               class="form-control"
                               (input)="filterCommandLog($event.target.value)"
                               placeholder="بر اساس کاربر و فرمان جستحو کنید...">
                    </div>
                    <!-- خروجی اکسل -->
                    <div class="col-auto px-1">
                        <button class="w-100 h-100 btn btn-success" (click)="exportExcelCommandLog()">
                            &nbsp; خروجی اکسل &nbsp;
                        </button>
                    </div>
                </div>
                <!-- جدول -->
                <div class="container-fluid row gx-0 gy-2 mt-2">
                    <div class="section border border-2 mt-2">
                        <table class="col-12 table table-striped rounded-3" id="Export_Excel_CommandLog">
                            <thead>
                                <tr class="text-center">
                                    <th>#</th>
                                    <th>زمان</th>
                                    <th>فرمان</th>
                                    <th>مقدار</th>
                                    <th>VIN</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="f14 text-center"
                                    *ngFor="let item of commandLogList; let i=index">
                                    <td>{{ i + 1 | faNum }}</td>
                                    <td>{{ (item.strDateTime | date:'HH:mm:ss - yyyy/MM/dd') | faNum }}</td>
                                    <td>{{ item.strCommand }}</td>
                                    <td>{{ item.strResponce }}</td>
                                    <td>{{ item.strVIN }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer d-flex justify-content-start">
                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
                    &nbsp; بستن &nbsp;
                </button>
            </div>
        </div>
    </div>
</div>
<!-- مودال سابقه فرامین -->
 <div class="modal fade" id="pidLogModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content dirI">
            <div class="modal-header dirI">
                <h5 class="modal-title" id="exampleModalLabel">
                    سابقه فرامین
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <!-- فیلتر -->
                <div class=" container-fluid row g-0">
                    <div class="col-10">
                        <input type="text"
                               class="form-control"
                               (input)="filterPidLog($event.target.value)"
                               placeholder="بر اساس کاربر و فرمان جستحو کنید...">
                    </div>
                    <!-- خروجی اکسل -->
                    <div class="col-auto px-1">
                        <button class="w-100 h-100 btn btn-success" (click)="exportExcelPidLog()">
                            &nbsp; خروجی اکسل &nbsp;
                        </button>
                    </div>
                </div>
                <!-- جدول -->
                <div class="container-fluid row gx-0 gy-2 mt-2">
                    <div class="section border border-2 mt-2">
                        <table class="col-12 table table-striped rounded-3" id="Export_Excel_PidLog">
                            <thead>
                                <tr class="text-center">
                                    <th>#</th>
                                    <th>زمان</th>
                                    <th>فرمان</th>
                                    <th>مقدار</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="f14 text-center"
                                    *ngFor="let item of pidLogList; let i=index">
                                    <td>{{ i + 1 | faNum }}</td>
                                    <td>{{ (item.strDateTime | date:'HH:mm:ss - yyyy/MM/dd') | faNum }}</td>
                                    <td >{{ item.strComment }}</td>
                                    <td dir="ltr">{{ item.strValue }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer d-flex justify-content-start">
                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
                    &nbsp; بستن &nbsp;
                </button>
            </div>
        </div>
    </div>
</div>

<!-- مودال داشبورد -->
 <div class="modal fade" id="obdModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content dirI">
            <div class="modal-header dirI">
                <h5 class="modal-title" id="exampleModalLabel">
                    داشبورد
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <!-- جدول -->
                <div class="container-fluid row gx-0 gy-2 mt-2">
                    <div class="section border border-2 mt-2">
                        <table class="col-12 table table-striped rounded-3" id="Export_Excel_PidLog">
                            <thead>
                                <tr class="text-center">
                                    <th>#</th>
                                    <th>نمودار</th>
                                    <th>عنوان</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="f14 text-center"
                                    *ngFor="let item of obdList; let i=index">
                                    <td>{{ i + 1 | faNum }}</td>
                                    <td (click)="openInNewTab(item.strPID)">
                                        <i class="fa fa-line-chart mx-2 fa-lg pointer"></i>
                                    </td>
                                    <td >{{ item.strComment }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer d-flex justify-content-start">
                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
                    &nbsp; بستن &nbsp;
                </button>
            </div>
        </div>
    </div>
</div>
<!-- مودال ویرایش -->
<div class="modal fade" id="EditModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content dirI">
            <div class="modal-header dirI">
                <h5 class="modal-title" id="exampleModalLabel">
                    ویرایش کاربر
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div [formGroup]="editForm">
                    <div class="container-fluid row g-2">
                        <div class="col-12 col-md-6">
                            <label for="">
                                <small>نام کاربر</small>
                            </label>
                            <input type="text" formControlName="strFullName" class="form-control">
                        </div>
                        <div class="col-12 col-md-6">
                            <label for="">
                                <small>تاریخ ثبت‌نام</small>
                            </label>
                            <input formControlName="strEshterakRegisterDate" class="form-control text-end">
                        </div>
                        <div class="col-md-12">
                            <label for="">
                                <small>تاریخ اعتبار</small>
                            </label>
                            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" 
                                [dateGregorianFormat]="'YYYY/MM/DD'"
                                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
                                <input formControlName="strEsterakEndDate" class="form-control text-end" readonly>
                            </ng-persian-datepicker>
                        </div>
                        <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2 mt-2">
                            <input class="form-check-input m-0" type="checkbox" id="bEnable" formControlName="bEnable">
                            <label class="form-check-label pointer text-muted me-2" for="bEnable"> فعال</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer d-flex justify-content-start">
                <button class="btn btn-success" (click)="submitEdit()">
                    &nbsp; تایید &nbsp;
                </button>
                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
                    &nbsp; بستن &nbsp;
                </button>
            </div>
        </div>
    </div>
</div>